{
  "it": {
    "profile": {
      "actions": {
        "changeEmail": "Cambia indirizzo email",
        "changeEmailAddress": "Cambia indirizzo email",
        "delete": "Elimina",
        "installApp": "Installa app 🚀",
        "launchApp": "Avvia app",
        "save": "Salva",
        "showQRCode": "Mostra codice QR"
      },
      "attributes": {
        "decimal_separator": "Notazione decimale della valuta",
        "email_address": "Email",
        "email_address_new": "Nuovo indirizzo email",
        "email_address_old": "Vecchio indirizzo email"
      },
      "labels": {
        "addToHomeScreen": "Aggiungi alla schermata Home",
        "allowAccess": "Dia a Ziggu accesso al Suo account",
        "allowImpersonation": "Consenta l'accesso a Ziggu",
        "allowImpersonationSubtext": "Potremmo dover accedere temporaneamente al Suo account per diagnosticare e risolvere un problema di assistenza clienti che ha segnalato. Il nostro accesso scade automaticamente dopo 7 giorni.",
        "allowRecording": "Consenta la registrazione della sessione",
        "allowRecordingSubtext": "Registrare la Sua sessione in Ziggu potrebbe aiutarci a individuare la causa di un problema che ha segnalato. La registrazione si interrompe automaticamente dopo 60 minuti o quando disattiva questa impostazione.",
        "and_x_other": "e 1 altro | e {other_count} altri",
        "bulk_invite_help": "Inviteremo i contatti selezionati sulla piattaforma. L'operazione può richiedere alcuni minuti.",
        "changeEmailAddress": "Cambia indirizzo email per {profile_name}",
        "checkYourInbox": "Le abbiamo inviato un'email a {email_address} per confermare",
        "confirmEmailUpdate": "L'email contiene un link per completare la procedura di aggiornamento. Ci contatti se riscontra problemi.",
        "confirmPasswordReset": "È stata inviata un'email con un link per reimpostare la password; controlli la Sua casella di posta. Ci contatti se riscontra problemi.",
        "currency": {
          "comma": "Virgola: 200.450,99",
          "point": "Punto: 200,450.99"
        },
        "emailAddressNewConfirm": "Conferma nuovo indirizzo email",
        "emailNotificationsInterval": "Frequenza email per le nuove notifiche",
        "emailNotificationsIntervalSubtext": "Qui può impostare la frequenza con cui la piattaforma controlla se ci sono aggiornamenti per Lei e Le invia un'email al riguardo.",
        "explainerSendEmail": "Una nuova email di invito verrà inviata a {name}",
        "explainerUpdateEmailActive": "{name} è già attivo sulla piattaforma. Verrà inviata un'email al nuovo indirizzo con un link per confermare la modifica dell'indirizzo email.",
        "explainerUpdateEmailInvited": "{name} è già stato invitato. Un nuovo invito verrà inviato al nuovo indirizzo email. Eventuali inviti precedenti non saranno più validi.",
        "followDevicePrompts": "Segua le indicazioni del Suo dispositivo per aggiungere l'app alla schermata Home",
        "impersonateProfile": "Impersona {profile_name}",
        "important": "Importante",
        "importantContent": "Verifichi di essere connesso alla piattaforma sul Suo dispositivo mobile tramite il browser web.",
        "installMobileApp": "Installa app mobile",
        "logInMobileDevice": "Acceda al Suo dispositivo mobile",
        "maintainerCannotImpersonatePartner": "Solo i membri del team con ruolo 'Proprietario' possono impersonare i partner.",
        "maintainerCannotUpdateEmailAddress": "Solo i membri del team con ruolo 'Proprietario' possono aggiornare l'indirizzo email",
        "multipleProfiles": "Questo utente ha più profili Ziggu. Solo l'utente può modificare l'indirizzo email.",
        "mustBeLoggedInBeforeQR": "Deve aver effettuato l'accesso sul Suo dispositivo mobile prima di scansionare il codice QR",
        "noEmailAddressAdded": "Nessun indirizzo email aggiunto",
        "onceLoggedInScan": "Una volta effettuato l'accesso, scansioni il codice QR per installare l'app sul Suo dispositivo",
        "openMobileBrowser": "Apra il Suo browser mobile e visiti",
        "public_api_access": "Token di accesso API pubblica",
        "redirectAutomatically": "Verrà reindirizzato automaticamente tra {seconds} secondi",
        "requestPasswordReset": "Reimposta password",
        "scanQRCode": "Scansioni il codice QR",
        "toLogInCredentials": "per accedere con le Sue credenziali",
        "updateEmailFailed": "Impossibile aggiornare il Suo indirizzo email. Riprovi o ci contatti.",
        "updateEmailSuccessful": "Il Suo indirizzo email è stato aggiornato con successo",
        "updateFailed": "Aggiornamento non riuscito. Riprovi o ci contatti."
      },
      "notifications": {
        "avatarChangedSuccessfully": "L'avatar è stato aggiornato. Le modifiche potrebbero richiedere fino a un'ora per essere visibili."
      },
      "toasts": {
        "bulk_invite": "Abbiamo iniziato a invitare i contatti selezionati sulla piattaforma",
        "emailResendSuccessfully": "Email inviata di nuovo con successo"
      },
      "validation": {
        "emailAddressBounce": {
          "hard_bounce": "L'indirizzo email non esiste, oppure non esiste più; modifichi l'indirizzo email.",
          "illegal_address": "Indirizzo email non valido: l'indirizzo email fornito potrebbe non essere impostato correttamente. Verifichi che l'indirizzo sia formattato correttamente e non contenga caratteri non validi.",
          "isp_block": "Blocco ISP: un blocco di solito significa che il nostro indirizzo IP o server è stato rifiutato dal server di posta ricevente.",
          "soft_bounce": "La persona è fuori sede, oppure la casella di posta è piena e non accetta email.",
          "spam_complaint": "La persona ha cliccato su \"Contrassegna come spam\" nel proprio client di posta; questo indirizzo email è stato disattivato. Se il destinatario La contatta e desidera ricevere di nuovo le email, ci contatti.",
          "spam_notification": "Le email sono state rifiutate dal server di posta. Ciò può dipendere da politiche aziendali rigide sul server di posta ricevente o da alcune parole nella Sua email segnalate dai filtri antispam."
        },
        "emailAddressBounced": "Errore indirizzo email",
        "emailDoesntMatch": "L'email non corrisponde",
        "emailTaken": "L'indirizzo email è già in uso. Se desidera comunque procedere con questa modifica, ci contatti tramite la chat.",
        "mustBeEmailAddress": "È richiesto un indirizzo email valido",
        "requireEmailAddress": "Email obbligatoria",
        "tooManyRequests": "È consentita una sola modifica dell'indirizzo email ogni 5 minuti. Riprovi più tardi."
      }
    }
  }
}
